// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__24aCg","head":"Table_head__1KhiC","col":"Table_col__iROLr"};